import { createApiCall } from 'lib/base';

const FETCH_INVESTCORE_USER_PROGRAM_ORDER_REBUNDLE_API_ID =
  'DASHBOARD/FETCH_INVESTCORE_USER_PROGRAM_ORDER_REBUNDLE_API';

const apiCall = createApiCall(
  FETCH_INVESTCORE_USER_PROGRAM_ORDER_REBUNDLE_API_ID,
  ({ payload }) => ({
    endpoint: `/api/admin/user-program-orders/rebundle`,
    method: 'POST',
    body: payload,
    notify: true,
  })
);

export default apiCall;
